/*
 * File: core.ts
 * File Created: 2024-02-23 09:35:37
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-28 09:24:58
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components";
import { IQuickUnit, QuickHelper } from "@root/core/utilities/quick-helper";
import { FindRouter, ObjectHelper, PermissionHelper, StringHelper } from "@root/core";
import { Component, Prop } from "vue-property-decorator";

@Component
export class BaseQuick extends BaseComponent {
    @Prop({ type: Object, required: true })
    quick!: IQuickUnit;

    /// private helper
    get isSimulate(): boolean {
        return !!this.quick?.value;
    }

    autoIncludeParents(quick: IQuickUnit, base: any = {}) {
        const parents = quick.parents == null ? null : quick.parents();
        if (parents == null) return base;

        const current = {
            select: null,
        };

        base.include = parents.reduce((final, parent) => {
            const quick = QuickHelper.extract(parent);
            final[StringHelper.camelize(quick.path)] = this.autoIncludeParents(
                quick,
                current,
            );
            return final;
        }, {});

        return base;
    }

    get autoIncludeFiles() {
        return {
            include: {
                files: true,
            },
        };
    }

    get autoWhereRecycled() {
        return {
            where: {
                recycled: false,
            },
        };
    }

    // get routeIcon(): string | null {
    //     const path = `/${this.$route.path.split("/")[1]}`;

    //     let routers = FindRouter({ path });
    //     if (routers.length === 0) return null;
    //     return routers[routers.length - 1].icon as string;
    // }

    autoWhereId(id) {
        return QuickHelper.autoWhereId(id);
    }

    /// auth
    checkDoable(allow, deny, row?: any) {
        let doable: boolean = true;
        if (deny != null) {
            if (PermissionHelper.check.call(this, deny, row)) return false;
        }
        if (allow != null) {
            if (!PermissionHelper.check.call(this, allow, row)) return false;
        }
        return true;
    }
    get readable() {
        return (
            this.quick.infRead &&
            this.checkDoable(this.quick.allowRead, this.quick.denyRead)
        );
    }
    get creatable() {
        return (
            this.quick.infCreate &&
            this.checkDoable(this.quick.allowCreate, this.quick.denyCreate)
        );
    }
    updatable(row) {
        return (
            this.quick.infUpdate &&
            this.checkDoable(this.quick.allowUpdate, this.quick.denyUpdate, row)
        );
    }
    deletable(row) {
        return (
            this.quick.infDelete &&
            this.checkDoable(this.quick.allowDelete, this.quick.denyDelete, row)
        );
    }
}
